import { getContrast } from 'polished';

/**
 * Given an array of colors and a background, returns the color with the greatest contrast.
 *
 * @param colors:string[] - array of colors to compare to the background.
 * @param background:string - color of the background
 */
export const maxLumaContrast = (colors, background) => {
  const contrasts = colors.map(color => getContrast(color, background));
  const maxContrast = Math.max(...contrasts);
  return colors[contrasts.indexOf(maxContrast)];
};
//# sourceMappingURL=maxLumaContrast.js.map